import { Badge } from "@/components/ui/badge";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

const STATUS_LABELS = {
  CALCULATED: "Calcolato", TO_VERIFY: "Da verificare", APPROVED: "Approvato",
  VERIFIED: "Verificato", OUTDATED: "Superato",
};

// Drill-down tracciabilità: KPI → calcolo → input → fonte → periodo → versione formula.
export default function KpiDrilldown({ calc, onClose }) {
  if (!calc) return null;
  const inputs = calc.input_snapshot || {};
  return (
    <Dialog open={!!calc} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-lg" data-testid="kpi-drilldown-dialog">
        <DialogHeader>
          <DialogTitle>Come è stato calcolato?</DialogTitle>
          <DialogDescription>Tracciabilità completa: input, formula, fonte e versione del calcolo.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 text-sm">
          <div className="flex items-center justify-between">
            <span className="text-slate-600">Metrica</span>
            <span className="font-semibold text-slate-900" data-testid="drilldown-metric">{calc.metric_code}</span>
          </div>
          <div className="rounded-md bg-slate-50 border border-slate-200 p-3">
            <p className="text-xs font-semibold text-slate-500 mb-1">Formula ({calc.formula_code})</p>
            <p className="text-slate-800 leading-relaxed" data-testid="drilldown-formula">{calc.formula_description || "—"}</p>
          </div>
          <div>
            <p className="text-xs font-semibold text-slate-500 mb-1">Input utilizzati</p>
            <Table>
              <TableHeader>
                <TableRow><TableHead>Input</TableHead><TableHead className="text-right">Valore</TableHead></TableRow>
              </TableHeader>
              <TableBody>
                {Object.entries(inputs).map(([k, v]) => (
                  <TableRow key={k}>
                    <TableCell className="text-slate-600">{k}</TableCell>
                    <TableCell className="text-right font-medium">
                      {typeof v === "object" ? JSON.stringify(v) : String(v)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          <div className="flex items-center justify-between rounded-md bg-green-50 border border-green-200 p-3">
            <span className="text-green-900 font-semibold">Risultato</span>
            <span className="text-xl font-extrabold text-green-900" data-testid="drilldown-result">
              {calc.result} {calc.unit || ""}
            </span>
          </div>
          <div className="flex flex-wrap items-center gap-2 text-xs text-slate-600">
            <Badge variant="outline" className="bg-slate-50" data-testid="drilldown-source">
              Fonte: {calc.source_type === "JOBTIMEHR_MOCK" ? "JOBTIMEHR — MOCK" : calc.source_type}
            </Badge>
            <Badge variant="outline" className="bg-slate-50">Versione calcolo: v{calc.version}</Badge>
            <Badge variant="outline" className="bg-amber-50 text-amber-800 border-amber-200">
              {STATUS_LABELS[calc.status] || calc.status}
            </Badge>
            <span>Calcolato il {new Date(calc.calculated_at).toLocaleString("it-IT")}</span>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
